import React, { useState } from "react";
import TabPanel from "./common/TabPanel";
import ParameterTable from "./common/ParameterTable";
// import "./css/OtherParameters.css";  // Import the CSS file

// Handling advanced parameters
// Daily costs are not included in the list, they are calculated under the hood
export const parameterGroups = {
  penalties: {
    category: "Penalties",
    inputs: [
      { label: "Non ZEV penalty", description: "Daily penalty for non-zero emission trucks", id: "non_ze_penalty", defaultValue: 20 },
    ],
  },
  maintenance: {
    category: "Maintenance",
    inputs: [
      { label: "Diesel maintenance", description: "Cost per mile for maintenance (diesel)", id: "diesel_maint", defaultValue: 0.21 },
      { label: "Electric maintenance", description: "Cost per mile for maintenance (electric)", id: "elec_maint", defaultValue: 0.1 },
    ],
  },
  insurance: {
    category: "Insurance",
    inputs: [
      { label: "Diesel insurance cost", description: "Annual insurance cost (diesel)", id: "diesel_ins_yr", defaultValue: 15000 },
      { label: "Electric insurance cost", description: "Annual insurance cost (electric)", id: "elec_ins_yr", defaultValue: 15000 },
    ],
  },
  dieselTruckCost: {
    category: "Diesel Truck Cost",
    inputs: [
      { label: "Diesel truck MSPR", description: "Purchase price of a diesel truck", id: "diesel_price", defaultValue: 150000 },
      { label: "Diesel MPG", description: "MPG (miles per gallon) of diesel trucks", id: "diesel_mpg", defaultValue: 6.5 },
    ],
  },
  truckLife: {
    category: "Truck Operational Life",
    inputs: [
      { label: "Electric truck life", description: "Expected operational life of electric trucks in years", id: "electric_life", defaultValue: 12 },
      { label: "Diesel truck life", description: "Expected operational life of diesel trucks in years", id: "diesel_life", defaultValue: 12 },
    ],
  },
  depotCharging: {
    category: "Depot Charging",
    inputs: [
      { label: "Demand charge", description: "Monthly power demand charge ($/kW)", id: "demand_charge", defaultValue: 0.0 },
    ],
  },
  publicCharging: {
    category: "Public Charging",
    inputs: [
      { label: "Public charging cost", description: "Additional cost per kWh at public stations", id: "pub_charge_cost", defaultValue: 0.2 },
    ],
  },
  diesel: {
    category: "Diesel",
    inputs: [
      { label: "Fuel cost", description: "Cost per gallon of diesel", id: "fuel_cost", defaultValue: 5.387 },
    ],
  },
};

// Define tab configuration
const parameterTabs = [
  { id: "maintenance", label: "Maintenance" },
  { id: "insurance", label: "Insurance" },
  { id: "penalties", label: "Penalties" }
];

// Initialize the parameters
export const initializeDefaultParameters = () => {
  const defaults = {};
  Object.values(parameterGroups).forEach((group) => {
    group.inputs.forEach((input) => {
      defaults[input.id] = input.defaultValue ?? 0;
    });
  });
  return defaults;
};

const OtherParameters = ({ otherParameters, setOtherParameters }) => {
  const [activeTab, setActiveTab] = useState("maintenance");

  const handleInputChange = (id, value) => {
    setOtherParameters(prev => ({ ...prev, [id]: value }));
  };

  const formatCurrency = (value) => value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  const renderContent = (tabId) => {
    const descriptions = {
      maintenance: "Configure maintenance costs for both electric and diesel trucks. Electric trucks generally have lower maintenance costs due to fewer moving parts and simpler powertrains.",
      insurance: "Configure insurance costs for both electric and diesel trucks. Insurance premiums may vary based on vehicle type and value.",
      penalties: "Operating in certain areas may incur additional penalties if you are not using zero-emission vehicles. Enter the estimated daily costs per truck for this, if applicable to your operational area."
    };
    const group = parameterGroups[tabId];
    const formatter = tabId === 'maintenance' ? (val) => Number(val).toFixed(2) : formatCurrency;

    return (
      <div>
        <p className="text-gray-600 mb-4">{descriptions[tabId]}</p>
        <ParameterTable
          parameters={group.inputs}
          values={otherParameters}
          onValueChange={handleInputChange}
          formatValue={formatter}
        />
      </div>
    );
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <TabPanel
        tabs={parameterTabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      >
        {renderContent('maintenance')}
        {renderContent('insurance')}
        {renderContent('penalties')}
      </TabPanel>
    </div>
  );
};

export default OtherParameters; 